export default __webpack_public_path__ + "829ddb0b1d13ae753d61e12690e065ba.svg";